iScreenWizard.factory('Feedbackcategorie', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('feedbackcategorie').then(function (response) {
                var feedbackcategorieen = response.data;
                resolve(feedbackcategorieen);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('feedbackcategorie/'+id).then(function (response) {
                var feedbackcategorie = response.data;
                resolve(feedbackcategorie);
            }, reject);
        });
    };

    return data;
});